import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ae3be7c&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5ae3be7c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae3be7c')) {
      api.createRecord('5ae3be7c', component.options)
    } else {
      api.reload('5ae3be7c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5ae3be7c&lang=pug", function () {
      api.rerender('5ae3be7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/upgradeTest/viewExplain/index.vue"
export default component.exports